<div class="ap">
    <div class="ap-flex ap-flex-row ap-flex-sm-column-reverse ap-margin-bottom-4">
        <div class="ap-flex-grow-1 ap-flex-shrink-1">
            <h2>{{ content.TITLE | apContent }}</h2>
            @if (pairingCodeIsInvalid) {
                <ap-notification status="warning">{{ pairingCodeInvalidMessage }}</ap-notification>
            }
            <p>{{ content.PARAGRAPH | apContent }}</p>
            <div class="ap-grid ap-grid-cols-gt-sm-2">
                <div class="ap-col-span-gt-sm-1">
                    <ap-input [formControl]="control" [label]="content.INPUT_LABEL | apContent" [maxlength]="8" type="text"></ap-input>
                </div>
            </div>
        </div>
        <div class="ap-flex-grow-1 ap-flex-shrink-0 ap-text-align-center">
            <ap-illustration [name]="'aanmelden'" [width]="'185'" [height]="'185'"></ap-illustration>
        </div>
    </div>
    <ap-button (onClick)="onClick()">{{ content.SUBMIT_BUTTON | apContent }}</ap-button>
</div>
